import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Drawer as MuiDrawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HomeIcon from '@mui/icons-material/Home';
import TableBarIcon from '@mui/icons-material/TableBar';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import StickyNote2SharpIcon from '@mui/icons-material/StickyNote2Sharp';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import AddCardIcon from '@mui/icons-material/AddCard';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
// import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { useNavigate, useLocation } from 'react-router-dom';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AssessmentIcon from "@mui/icons-material/Assessment"; // Sales Summary
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"; // Sales Details
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"; // Collection
import Inventory2Icon from "@mui/icons-material/Inventory2";

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const menuItemsByRole = {
  admin: [
    { label: 'Home', icon: <HomeIcon />, path: '/admin/home' },
    { label: 'Manage Unit', icon: <AdUnitsIcon />, path: '/admin/add-unit' },
    { label: 'Preferenes', icon: <AdUnitsIcon />, path: '/admin/options' },
    { label: 'Manage Category', icon: <AddCardIcon />, path: '/admin/add-category' },
    { label: 'Service Areas', icon: <AddBusinessIcon />, path: '/admin/service-areas' },
    { label: 'Price Category', icon: <CreditScoreIcon />, path: '/admin/add-price-category' },
    { label: 'Manage Table', icon: <TableBarIcon />, path: '/admin/tables' },
    { label: 'Manage Menu', icon: <RestaurantMenuIcon />, path: '/admin/menu' },
    { label: 'Order History', icon: <StickyNote2SharpIcon />, path: '/admin/orders' },
    { label: 'Manage Payments', icon: <CreditScoreIcon />, path: '/admin/payments' },
    { label: 'Add User', icon: <PersonAddAlt1Icon />, path: '/admin/add-user' },
    { label: 'GST Manager', icon: <CreditScoreIcon />, path: '/admin/gst' },
    {
    label: 'Reports',
    icon: <ReceiptIcon />,
    children: [
      {
        label: 'Sales Summary',
        icon: <AssessmentIcon  />,
        path: '/admin/reports/sales-summary',
      },
      {
        label: 'Sales Details',
        icon: <ReceiptLongIcon  />,
        path: '/admin/reports/sales-details',
      },
      {
        label: 'Collection',
        icon: <AccountBalanceWalletIcon  />,
        path: '/admin/reports/collection',
      },
      {
        label: 'Item Wise Details',
        icon: <Inventory2Icon  />,
        path: '/admin/reports/item-wise-details',
      },
    ],
  },
  ],
  kitchen_staff: [
    { label: 'Home', icon: <HomeIcon />, path: '/kitchen_staff/home' },
    { label: 'View Orders', icon: <StickyNote2SharpIcon />, path: '/kitchen_staff/orders' },
    { label: 'Menu Items', icon: <RestaurantMenuIcon />, path: '/kitchen_staff/menu-items'},
  ],
  servers: [
    { label: 'Home', icon: <HomeIcon />, path: '/servers/home' },
    { label: 'Serve Orders', icon: <TableBarIcon />, path: '/servers/orders' },
    { label: 'Cash Payment', icon: <AddCardIcon />, path: '/servers/payment' },
  ],
  customer: [
    { label: 'Home', icon: <HomeIcon />, path: '/customer/home' },
    { label: 'Menu', icon: <RestaurantMenuIcon />, path: '/customer/menu' },
    /*{ label: 'My Order', icon: <ShoppingCartIcon />, path: '/customer/MyOrder' },*/
    { label: 'Place Order', icon: <ShoppingCartIcon />, path: '/customer/order' },
    { label: 'Track Order', icon: <ShoppingCartCheckoutIcon />, path: '/customer/track-order' },
    { label: 'Request Bill', icon: <ReceiptIcon />, path: '/customer/bill' },
    { label: 'Make Payment', icon: <AddCardIcon />, path: '/customer/payments' },
  ],
  softwareadmin: [
    { label: 'Home', icon: <HomeIcon />, path: '/softwareadmin/home' },
    { label: 'Add Business', icon: <AddBusinessIcon />, path: '/softwareadmin/add-company' },
    { label: 'Master Menu', icon: <RestaurantMenuIcon />, path: '/softwareadmin/add-menu' },
  ],
  unit_manager: [
    { label: 'Home', icon: <HomeIcon />, path: '/unit_manager/home' },
    { label: 'Preferenes', icon: <AdUnitsIcon />, path: '/unit_manager/options' },
    { label: 'Manage Category', icon: <AddCardIcon />, path: '/unit_manager/add-category' },
    { label: 'Manage Table', icon: <TableBarIcon />, path: '/unit_manager/tables' },
    { label: 'Manage Menu', icon: <RestaurantMenuIcon />, path: '/unit_manager/menu' },
    { label: 'Orders', icon: <TableBarIcon />, path: '/unit_manager/order' },
    { label: 'Reset Bill', icon: <ReceiptIcon />, path: '/unit_manager/reset-bill' },
    { label: 'Order History', icon: <StickyNote2SharpIcon />, path: '/unit_manager/orders' },
    { label: 'Manage Payments', icon: <CreditScoreIcon />, path: '/unit_manager/payments' },
    { label: 'Add User', icon: <PersonAddAlt1Icon />, path: '/unit_manager/add-user' },
    {
    label: 'Reports',
    icon: <ReceiptIcon />,
    children: [
      {
        label: 'Sales Summary',
        icon: <AssessmentIcon  />,
        path: '/unit_manager/reports/sales-summary',
      },
      {
        label: 'Sales Details',
        icon: <ReceiptLongIcon  />,
        path: '/unit_manager/reports/sales-details',
      },
      {
        label: 'Collection',
        icon: <AccountBalanceWalletIcon  />,
        path: '/unit_manager/reports/collection',
      },
      {
        label: 'Item Wise Details',
        icon: <Inventory2Icon  />,
        path: '/unit_manager/reports/item-wise-details',
      },
    ],
  },
  ],
};

function Sidebar({ open, handleDrawerToggle, role, tableId, companyCode, unitCode, userId, companyName, unitType, isPureVeg, cartId, billingPreference }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [openReports, setOpenReports] = React.useState(false);
  // Hide sidebar when on landing page (/)
  if (location.pathname === '/') {
    return null;
  }

  const handleMenuItemClick = (path) => {
    let navigatePath = path;
    let navigateState = {};

    if (role.toLowerCase() === 'customer' && tableId && companyCode && unitCode) {
      const queryParams = new URLSearchParams({
        code: companyCode,
        unit: unitCode,
        id: tableId,
        type: unitType || 'Unknown',
        name: companyName || 'Unknown',
        isPureVeg: (isPureVeg || false).toString(),
        cartId: cartId || ""
      });
      navigatePath = `${path}?${queryParams.toString()}`;
      navigateState = { tableId, companyCode, unitCode, unitType, companyName, isPureVeg, orderId: localStorage.getItem('currentOrderId') || null };
    } else if (role.toLowerCase() === 'admin' && companyCode) {
      const queryParams = new URLSearchParams({
        code: companyCode,
        name: companyName || 'Unknown',
        isPureVeg: (isPureVeg || false).toString(),
      });
      navigatePath = `${path}?${queryParams.toString()}`;
      navigateState = { companyCode, companyName, isPureVeg };
    } else if (['unit_manager', 'kitchen_staff', 'servers'].includes(role.toLowerCase()) && unitCode && companyCode) {
      const queryParams = new URLSearchParams({
        unit: unitCode,
        code: companyCode,
        type: unitType || 'Unknown',
        name: companyName || 'Unknown',
        isPureVeg: (isPureVeg || false).toString(),
      });
      navigatePath = `${path}?${queryParams.toString()}`;
      navigateState = { unitCode, companyCode, unitType, companyName, isPureVeg };
    }

    console.log('Sidebar: Navigating to:', {
      navigatePath,
      role,
      userId,
      tableId,
      companyCode,
      unitCode,
      unitType,
      companyName,
      isPureVeg,
      navigateState,
    });
    navigate(navigatePath, { state: navigateState });
    handleDrawerToggle();
  };

  let filteredMenuItems = menuItemsByRole[role.toLowerCase()] || [];

// Hide server order/payment menus when billing preference = 0
if (role.toLowerCase() === "servers" && billingPreference === 0) {
  filteredMenuItems = filteredMenuItems.filter(
    item =>
      item.label !== "Serve Orders" &&
      item.label !== "Cash Payment"
  );
}

  return (
    <MuiDrawer
      variant="temporary"
      open={open}
      onClose={handleDrawerToggle}
      ModalProps={{ keepMounted: true }}
      sx={{
        '& .MuiDrawer-paper': {
          width: drawerWidth,
        },
      }}
    >
      <DrawerHeader>
        <IconButton onClick={handleDrawerToggle}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>
      <List>
        {/*{menuItemsByRole[role.toLowerCase()]?.map((item, index) => (*/}
        {/*{filteredMenuItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick(item.path)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}*/}

        {filteredMenuItems.map((item, index) => {
  if (item.children) {
    return (
      <React.Fragment key={index}>
        <ListItem disablePadding>
          <ListItemButton onClick={() => setOpenReports(!openReports)}>
            <ListItemIcon>{item.icon}</ListItemIcon>

            <ListItemText primary={item.label} />

            {openReports ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>

        <Collapse in={openReports} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((child, childIndex) => (
              <ListItem
                key={childIndex}
                disablePadding
                sx={{ pl: 4 }}
              >
                <ListItemButton
                  onClick={() => handleMenuItemClick(child.path)}
                >
                  <ListItemIcon>{child.icon}</ListItemIcon>

                  <ListItemText primary={child.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </React.Fragment>
    );
  }

  return (
    <ListItem key={index} disablePadding>
      <ListItemButton onClick={() => handleMenuItemClick(item.path)}>
        <ListItemIcon>{item.icon}</ListItemIcon>

        <ListItemText primary={item.label} />
      </ListItemButton>
    </ListItem>
  );
})}
      </List>
    </MuiDrawer>
  );
}

export default Sidebar;